document.addEventListener('DOMContentLoaded', () => {
  const inventoryData = window.variantAvailableWithSupplierStock || {};

  function updateMax(variantId) {
    const qtyInputs = document.querySelectorAll('input[id^="Quantity-"]');
    const total = inventoryData[variantId];
    if (total === undefined || total === null) return;
    qtyInputs.forEach((input) => {
      input.setAttribute('max', total);
    });
    const displayedTotal = total > 100 ? '100+' : total;
    document.querySelectorAll('[data-stock-quantity]').forEach((stockCue) => {
      stockCue.textContent = `${displayedTotal} in stock`;
    });
  }

  const urlVariantId = new URLSearchParams(window.location.search).get('variant');
  const formVariantId = document.querySelector('form[action^="/cart"] input[name="id"]')?.value;
  const initialVariantId = urlVariantId || window.CurrentVariant?.id || formVariantId;
  if (initialVariantId) updateMax(String(initialVariantId));

  document.addEventListener('globalVariantIdUpdated', (e) => {
    const id = String(e.detail.variantId);
    updateMax(id);
  });
});